import NavBar from "./components/Navbar/Navbar.js";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./components/Navbar/Navbar.css";
import Home from "./components/Pages/Home.js";
import About from "./components/Pages/About.js";
import Portfolio from "./components/Pages/Portfolio.js";
import Training from "./components/Pages/Training.js";
import Service from "./components/Pages/Service.js";
import Contact from "./components/Pages/Contact.js";
import Blog from "./components/Pages/Blog/Blog.js";
import Career from "./components/Pages/Career.js";
import Technology from "./components/Pages/Technology.js";
// Service sub-pages
import SoftwareDevelopment from "./components/Pages/SoftwareDevelopment.js";
import GameDevelopment from "./components/Pages/GameDevelopment.js";
import CasinoSportsbook from "./components/Pages/CasinoSportsbook.js";
import ARVRApplicationDevelopment from "./components/Pages/ARVRApplicationDevelopment";
import WebsiteDevelopment from "./components/Pages/WebsiteDevelopment";
import AppDevelopment from "./components/Pages/AppDevelopment";
import DevOpsSolutions from "./components/Pages/DevOpsSolutions";
import ITSupportSolutions from "./components/Pages/ITSupportSolutions";
import TrainingPrograms from "./components/Pages/TrainingPrograms";
import DigitalMarketing from "./components/Pages/DigitalMarketing";

import "bootstrap/dist/css/bootstrap.min.css";
import BlogSub_1 from "./components/Pages/Blog/BlogSub_1.js";
import TermsConditions from "./components/Pages/TermsCondition.js";
import PrivacyPolicy from "./components/Pages/PrivacyPolicy.js";
import IoTSolutions from "./components/Pages/IotSolutions.js";
import DroneAndEducation from "./components/Pages/DroneAndEducation.js";
import Login from "./components/Pages/Login.js";
import ProtectedRoute from "./components/Navbar/ProtectedRoute.js";
import { useEffect } from "react";

function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const authData = JSON.parse(localStorage.getItem("auth"));

  //     if (authData && new Date().getTime() > authData.expiry) {
  //       localStorage.removeItem("auth");
  //       alert("Session expired. Please login again.");
  //       navigate("/login");
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [navigate]);

  return (
    <>
      {/* {location.pathname !== "/login" && */}
       <NavBar />
      {/* } */}
      <Routes>
        {/* <Route path="/login" element={<Login />} /> */}

        <Route
          path="/"
          element={
            // <ProtectedRoute>
              <Home />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/about"
          element={
            // <ProtectedRoute>
              <About />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/portfolio"
          element={
            // <ProtectedRoute>
              <Portfolio />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/trainings"
          element={
            // <ProtectedRoute>
              <Training />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <ProtectedRoute>
              <Contact />
            </ProtectedRoute>
          }
        />
        <Route
          path="/blog"
          element={
            // <ProtectedRoute>
              <Blog />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/blogsub_1"
          element={
            // <ProtectedRoute>
              <BlogSub_1 />
            // </ProtectedRoute>
          }
        />

        <Route
          path="/services"
          element={
            // <ProtectedRoute>
              <Service />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/career"
          element={
            // <ProtectedRoute>
              <Career />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/technology"
          element={
            // <ProtectedRoute>
              <Technology />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/termscondition"
          element={
            // <ProtectedRoute>
              <TermsConditions />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/privacypolicy"
          element={
            // <ProtectedRoute>
              <PrivacyPolicy />
            // </ProtectedRoute>
          }
        />

        {/* Services */}
        <Route
          path="/services/DroneAndEducation"
          element={
            // <ProtectedRoute>
              <DroneAndEducation />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/SoftwareDevelopment"
          element={
            // <ProtectedRoute>
              <SoftwareDevelopment />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/GameDevelopment"
          element={
            // <ProtectedRoute>
              <GameDevelopment />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/CasinoSportsbook"
          element={
            // <ProtectedRoute>
              <CasinoSportsbook />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/IoTSolutions"
          element={
            // <ProtectedRoute>
              <IoTSolutions />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/ARVRApplicationDevelopment"
          element={
            // <ProtectedRoute>
              <ARVRApplicationDevelopment />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/WebsiteDevelopment"
          element={
            // <ProtectedRoute>
              <WebsiteDevelopment />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/AppDevelopment"
          element={
            // <ProtectedRoute>
              <AppDevelopment />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/DevOpsSolutions"
          element={
            // <ProtectedRoute>
              <DevOpsSolutions />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/ITSupportSolutions"
          element={
            // <ProtectedRoute>
              <ITSupportSolutions />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/TrainingPrograms"
          element={
            // <ProtectedRoute>
              <TrainingPrograms />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/services/DigitalMarketing"
          element={
            // <ProtectedRoute>
              <DigitalMarketing />
            // </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
